var _filter, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _text, _rect4, _text2, _rect5, _rect6, _text3, _rect7, _rect8, _text4, _rect9, _rect10, _text5, _rect11, _rect12, _text6, _rect13, _rect14, _text7, _rect15, _rect16, _text8, _rect17, _pattern, _rect18, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _rect19, _rect20, _rect21, _rect22, _text9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeflowHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    width: 800,
    height: 520,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f8fbff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#eef4ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodeGrad1",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4f8cff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2563eb",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodeGrad2",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#34d399",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#059669",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodeGrad3",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f59e0b",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#d97706",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodeGrad4",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#a78bfa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7c3aed",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 6,
    floodColor: "#000",
    floodOpacity: 0.12
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 760,
    height: 480,
    rx: 16,
    fill: "url(#bgGrad)",
    stroke: "#dbeafe",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 760,
    height: 44,
    rx: 16,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 48,
    width: 760,
    height: 16,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 42,
    r: 7,
    fill: "#ef4444"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 42,
    r: 7,
    fill: "#f59e0b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 42,
    r: 7,
    fill: "#22c55e"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 47,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fontWeight: 600,
    fill: "#1e3a5f",
    textAnchor: "middle"
  }, "NodeFlow - Visual Workflow Designer")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 78,
    width: 160,
    height: 410,
    rx: 10,
    fill: "#fff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 104,
    fontFamily: "Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#334155",
    textAnchor: "middle"
  }, "Node Library")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 120,
    width: 132,
    height: 32,
    rx: 6,
    fill: "#f1f5f9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 130,
    width: 12,
    height: 12,
    rx: 3,
    fill: "#2563eb"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 140,
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fill: "#475569"
  }, "Tag Read/Write")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 160,
    width: 132,
    height: 32,
    rx: 6,
    fill: "#f1f5f9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 170,
    width: 12,
    height: 12,
    rx: 3,
    fill: "#059669"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 180,
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fill: "#475569"
  }, "MES / OEE")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 200,
    width: 132,
    height: 32,
    rx: 6,
    fill: "#f1f5f9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 210,
    width: 12,
    height: 12,
    rx: 3,
    fill: "#d97706"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 220,
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fill: "#475569"
  }, "EMS Energy")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 240,
    width: 132,
    height: 32,
    rx: 6,
    fill: "#f1f5f9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 250,
    width: 12,
    height: 12,
    rx: 3,
    fill: "#7c3aed"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 260,
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fill: "#475569"
  }, "MQTT / API")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 280,
    width: 132,
    height: 32,
    rx: 6,
    fill: "#f1f5f9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 290,
    width: 12,
    height: 12,
    rx: 3,
    fill: "#db2777"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 300,
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fill: "#475569"
  }, "Database")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 320,
    width: 132,
    height: 32,
    rx: 6,
    fill: "#f1f5f9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 330,
    width: 12,
    height: 12,
    rx: 3,
    fill: "#0891b2"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 340,
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fill: "#475569"
  }, "Scripting")), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 78,
    width: 554,
    height: 410,
    rx: 10,
    fill: "#fff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 30,
    height: 30,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1,
    fill: "#e2e8f0"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 78,
    width: 554,
    height: 410,
    rx: 10,
    fill: "url(#grid)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 140,
    width: 130,
    height: 58,
    rx: 10,
    fill: "url(#nodeGrad1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 169,
    r: 14,
    fill: "#fff",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    x: 285,
    y: 174,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#fff",
    textAnchor: "middle"
  }, "\u26A1"), /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 164,
    fontFamily: "Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#fff"
  }, "Timer Trigger"), /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 182,
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fill: "#dbeafe"
  }, "Every 1 minute"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 130,
    width: 130,
    height: 58,
    rx: 10,
    fill: "url(#nodeGrad2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 159,
    r: 14,
    fill: "#fff",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    x: 485,
    y: 164,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#fff",
    textAnchor: "middle"
  }, "\uD83C\uDFED"), /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 154,
    fontFamily: "Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#fff"
  }, "Machine"), /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 172,
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fill: "#d1fae5"
  }, "Line-01"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 150,
    width: 70,
    height: 70,
    rx: 14,
    fill: "url(#nodeGrad4)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 695,
    y: 188,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#fff",
    textAnchor: "middle"
  }, "\uD83D\uDDC4"), /*#__PURE__*/React.createElement("text", {
    x: 695,
    y: 208,
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    fill: "#ede9fe",
    textAnchor: "middle"
  }, "Logger"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 260,
    width: 110,
    height: 52,
    rx: 10,
    fill: "url(#nodeGrad3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 286,
    r: 12,
    fill: "#fff",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    x: 495,
    y: 291,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#fff",
    textAnchor: "middle"
  }, "\u270E"), /*#__PURE__*/React.createElement("text", {
    x: 515,
    y: 284,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#fff"
  }, "Transform"), /*#__PURE__*/React.createElement("text", {
    x: 515,
    y: 299,
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    fill: "#fef3c7"
  }, "JSON mapping"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 330,
    width: 120,
    height: 52,
    rx: 10,
    fill: "url(#nodeGrad4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 356,
    r: 12,
    fill: "#fff",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    x: 305,
    y: 361,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#fff",
    textAnchor: "middle"
  }, "\u2601"), /*#__PURE__*/React.createElement("text", {
    x: 325,
    y: 354,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#fff"
  }, "MQTT Pub"), /*#__PURE__*/React.createElement("text", {
    x: 325,
    y: 369,
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    fill: "#ede9fe"
  }, "cloudview/topic"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M390 169 Q425 169 460 159",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 3,
    strokeDasharray: "6,4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M590 159 Q625 169 660 185",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 3,
    strokeDasharray: "6,4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M525 188 Q525 224 525 260",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 3,
    strokeDasharray: "6,4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M525 312 Q525 340 400 356",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 3,
    strokeDasharray: "6,4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 169,
    r: 5,
    fill: "#2563eb"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 159,
    r: 5,
    fill: "#059669"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 590,
    cy: 159,
    r: 5,
    fill: "#059669"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 660,
    cy: 185,
    r: 5,
    fill: "#7c3aed"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 525,
    cy: 188,
    r: 5,
    fill: "#059669"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 525,
    cy: 260,
    r: 5,
    fill: "#d97706"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 525,
    cy: 312,
    r: 5,
    fill: "#d97706"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 356,
    r: 5,
    fill: "#7c3aed"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 450,
    width: 514,
    height: 28,
    rx: 6,
    fill: "#f8fafc",
    stroke: "#e2e8f0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 458,
    width: 40,
    height: 12,
    rx: 3,
    fill: "#3b82f6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 458,
    width: 40,
    height: 12,
    rx: 3,
    fill: "#10b981"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 458,
    width: 40,
    height: 12,
    rx: 3,
    fill: "#f59e0b"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 468,
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b",
    textAnchor: "end"
  }, "6 nodes \u2022 4 edges")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeflowHero);
export default __webpack_public_path__ + "static/media/nodeflow_hero.fb276826147904485b0bf8a03af95086.svg";
export { ForwardRef as ReactComponent };